import { Link } from 'react-router-dom';
import ResourceCard from '@/components/base/ResourceCard';
import { getCategoryName, type Resource } from '@/mocks/resources';

export default function RelatedList({ items }: { items: Resource[] }) {
  if (items.length === 0) return null;

  return (
    <section className="mt-14">
      <div className="mb-5 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            相关推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            与当前作品同属「{getCategoryName(items[0].category)}」分类，你可能也喜欢
          </p>
        </div>
        <Link
          to={`/category/${items[0].category}`}
          className="hidden cursor-pointer items-center gap-1 text-sm font-label text-primary-600 transition-colors hover:text-primary-700 sm:inline-flex"
        >
          更多同类
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {items.map((item) => (
          <ResourceCard key={item.id} resource={item} />
        ))}
      </div>
    </section>
  );
}